import { Component, OnInit } from '@angular/core';
import { ObjectivesService } from '../objectives.service';
import { CVLocalizationService } from '../../../reusables/services/cv-localization.service';

@Component({
  selector: 'cv-objective-groups-card-view',
  templateUrl: './objective-groups-card-view.component.html',
  styleUrls: ['./objective-groups-card-view.component.scss']
})
export class ObjectiveGroupsCardViewComponent implements OnInit {
    filterSelectedText = "";
    showMetricType = [true, true];
    LocalizationMessages: Map<string, string>;

    constructor(
        public objectiveService: ObjectivesService,
        private cvLocalizationService: CVLocalizationService,
    ) { }

    ngOnInit(): void {
        this.cvLocalizationService.GetSection("Objectives").then(res => {
            this.LocalizationMessages = res;
        });
    }

    clearSelectedSearch() {
        this.filterSelectedText = "";
    }

    applyFilter() { }

    backClick() {
        this.objectiveService.showLandingHeader = true;
        this.objectiveService.showGroupsCardView = false;

        this.objectiveService.selectedGroupItem = null;
        this.showMetricType = [true, true];
    }

    scrollToTop() {
        // Force a scroll to the top of the page since scrolling on configure pages causes odd scrolling
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    editObjectiveClick(obj) {
        this.scrollToTop();

        this.objectiveService.editObjective(obj, false);
    }

    clickNew() {
        this.scrollToTop();

        this.objectiveService.showAddEditObjective = true;

        this.objectiveService.addEdit.originalObjectives = [];
        this.objectiveService.addEdit.editedObjectives = [];
        this.objectiveService.addNewObjective(0, 0);
        this.objectiveService.addEdit.selectedObjective = 0;
        this.objectiveService.addEdit.assignedGroups = [];
        this.objectiveService.addEdit.originalAssignedGroups = [];
        this.objectiveService.addEdit.MetricID = 0;
        this.objectiveService.addEdit.MetricName = "";
        this.objectiveService.addEdit.MetricValueType = null;
        this.objectiveService.addEdit.MetricObjectiveType = null;
        this.objectiveService.addEdit.MetricValueTimeType = null;
        this.objectiveService.addEdit.MetricDirection = null;
        this.objectiveService.addEdit.MetricIsRealtime = null;
        this.objectiveService.addEdit.selectedRange = null;

        this.objectiveService.showGroupsCardView = false;
    }

    isLowestCard(obj) {
        let lowest = 6;
        for (let loadedObjective of this.objectiveService.loadedObjectives) {
            if (loadedObjective.combinedObj.ObjectiveID == obj.combinedObj.ObjectiveID || loadedObjective.combinedObj.GroupingID == obj.combinedObj.ObjectiveID) {
                if (loadedObjective.combinedObj.AssignedLevel < lowest)
                    lowest = loadedObjective.combinedObj.AssignedLevel;
            }
        }

        return lowest;
    }

    isInheritedCard(obj) {
        if (this.objectiveService.selectedGroupItem == null)
            return false;

        if (this.objectiveService.selectedGroupItem.BaseGroupType == 0) { // Emp
            for (let empAssignment of obj.assignments.emp) {
                if (empAssignment.GroupLevel == this.objectiveService.selectedGroupItem.GroupLevel && empAssignment.GroupID == this.objectiveService.selectedGroupItem.GroupID) // Direct match found
                    return false;
            }
        }
        else if (this.objectiveService.selectedGroupItem.BaseGroupType == 1) { // Rec
            for (let recAssignment of obj.assignments.rec) {
                if (recAssignment.GroupLevel == this.objectiveService.selectedGroupItem.GroupLevel && recAssignment.GroupID == this.objectiveService.selectedGroupItem.GroupID) // Direct match found
                    return false;
            }
        }
        else
            return false; // Attribute cannot inherit

        return true; // If item in list but a match was not found then it was inherited
    }

    removeCard(evt, obj) {
        evt.stopPropagation();

        window["showConfirmDialog"](this.LocalizationMessages.get("Confirm_Remove_Message"),
            [
                {
                    text: this.LocalizationMessages.get("Yes"),
                    click: () => {
                        (jQuery(".errorDialog") as any).dialog("close");

                        this.removeCardConfirm(obj);
                    }
                },
                {
                    text: this.LocalizationMessages.get("No"),
                    click: () => {
                        (jQuery(".errorDialog") as any).dialog("close");
                    }
                }
            ], this.LocalizationMessages.get("Confirm_Delete"));
    }

    removeCardConfirm(obj) {
        let stringToRemove = "";
        let intList = [];

        if (obj.combinedObj.GroupingID == 0) { // Core card so remove all the sub cards too
            for (let loadedObjective of this.objectiveService.loadedObjectives) {
                if (obj.combinedObj.ObjectiveID == loadedObjective.combinedObj.ObjectiveID || obj.combinedObj.ObjectiveID == loadedObjective.combinedObj.GroupingID) {
                    if (stringToRemove == "") {
                        stringToRemove += loadedObjective.combinedObj.ObjectiveID;
                        intList.push(loadedObjective.combinedObj.ObjectiveID);
                    }
                    else {
                        stringToRemove += "," + loadedObjective.combinedObj.ObjectiveID;
                        intList.push(loadedObjective.combinedObj.ObjectiveID);
                    }
                }
            }
        }
        else { // Remove only the sub card selected
            stringToRemove += obj.combinedObj.ObjectiveID;
            intList.push(obj.combinedObj.ObjectiveID);
        }

        this.objectiveService.removeObjectives(stringToRemove);

        for (var i = 0; i < this.objectiveService.loadedObjectives.length; i++) {
            for (var int of intList) {
                if (int == this.objectiveService.loadedObjectives[i].combinedObj.ObjectiveID) {
                    if (this.objectiveService.loadedObjectives[i].combinedObj.GroupingID == 0)
                        this.objectiveService.selectedMetric.count--;

                    this.objectiveService.loadedObjectives.splice(i, 1);
                    i--;
                }
            }
        }

        this.objectiveService.setGroupObjByMetric();
    }

    objFilter(objectives, objectiveId) {
        return objectives.filter(o => o.combinedObj.GroupingID == objectiveId);
    }

    paletteFilter(palettes, obj) {
        return palettes.filter(p => p.ObjectivePaletteID == obj.combinedObj.ObjectivePaletteID);
    }
}
